/**
 * Component: Greek characters validation
 * ------------------------------------------------------------------------------
 * Translate greek alphabet characters in latin ones.
 *
 * @namespace greekValidation
 */
import greekUtils from 'greek-utils';
import {on} from '~/helpers/utils';

/**
 * DOM selectors.
 */
const selectors = {
  input: '.field__input',
};

/**
 * Create a new object.
 */
export default () => {

  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    input: [...document.querySelectorAll(selectors.input)],
  };

  /**
   * Initialise component.
   */
  function init() {
    if (Shopify.Checkout.step !== 'contact_information') {
      return;
    }

    setEventListeners();
  }

  /**
   * Set event listeners.
   */
  function setEventListeners() {
    nodeSelectors.input.forEach((input) => {
      on('blur', input, () => {
        const inputValue = input.value;
        input.value = greekUtils.toPhoneticLatin(inputValue);
      });
    });
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  });
};
